module.exports = __webpack_public_path__ + "static/media/cookie5.7e6cee4c.png";